import React, { useMemo, useState } from 'react'
import FactureDetails from '../../components/facture/details/FactureDetails'
import { useDispatch, useSelector } from 'react-redux'
import { UPDATE_VENTE_PATH } from '../../utils/navigation_paths'
import { setFactureSelectedClient, setIsUpdatingFacture } from '../../redux/reducers/factureArticles'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import ApiController from '../../redux/api_controller'
import { useAgenceId } from '../../hooks/useAgenceId'
import { useAgenceName } from '../../hooks/useAgenceName'
import ConfirmAction from '../../components/ConfirmAction'
import { toast } from 'react-toastify'

const VenteDetailsPage = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loadingFacture, setLoadingFacture] = useState(false)
    const { currentVente, currentVenteDetails } = useSelector(state => state.ventes)
    const [paymentModalIsOpen, setPaymentModalIsOpen] = useState(false);
    let factureDate = new Date(currentVente.created_at)
    let total = currentVenteDetails?.montantTotal || 0
    const venteTableFormat = currentVenteDetails?.articles
    const { agenceId: idAgence } = useAgenceId()
    const { nomAgence } = useAgenceName()

    useEffect(() => {
        dispatch(setIsUpdatingFacture(false))
        // dispatch(initializeCurrentDepenseDetails())
        setLoadingFacture(true)
        ApiController.ventes.getventeById(currentVente.id).finally(() => {
            setLoadingFacture(false)
        })
    }, []);

    function openPaymentModal() {
        setPaymentModalIsOpen(true);
    }

    const columns = useMemo(() => [
        {
            dataField: "product.name",
            text: "Désignation",
            headerClasses: 'custom-table-column text-white'
        },
        {
            dataField: "quantity",
            text: "Quantité",
            headerClasses: 'custom-table-column text-white'
        },
        {
            dataField: "product.prixVente",
            text: "Prix Unitaire",
            headerClasses: 'custom-table-column text-white'
        },
        {
            dataField: "montant",
            text: "Total",
            headerClasses: 'custom-table-column text-white',
        }
    ], [])

    const onEdit = () => {
        // console.log({ currentVente });
        // ! on active la mise a jour
        dispatch(setIsUpdatingFacture(true))
        if (currentVente.client) {
            let clientId = currentVente.client.id
            let fullName = currentVente.client.firstName + ' ' + currentVente.client.lastName
            // ! we need the selected client to show in the select form when we edit
            // dispatch(setSelectedClient({ value: clientId, label: fullName }))
            dispatch(setFactureSelectedClient({ value: clientId, label: fullName }))
        }
        navigate(`/agences/${idAgence}/${nomAgence}/ventes/update`)
    }

    const payerVente = () => {
        // setLoading(true);
        let data = { status: "PAYE" };
        ApiController.ventes.updatevente(currentVente.id, data, dispatch)
            .then((response) => {
                ApiController.ventes.getventeById(currentVente.id)
                toast.success("Facture payée avec succès");
            })
            .catch((err) => {
                console.log(err);
                // closeModal();
                toast.error("La payment n'a pas réuissi");
            })
            .finally(() => {
                setPaymentModalIsOpen(false)
            });
    };

    return (
        <div>
            <ConfirmAction
                modalText="Paiement vente"
                text={<p>Le montant total a payer est de <b>{total} XOF</b></p>}
                modalIsOpen={paymentModalIsOpen}
                cancel={() => setPaymentModalIsOpen(false)}
                closeModal={() => setPaymentModalIsOpen(false)}
                validate={payerVente}
            />
            <FactureDetails
                factureFor="Client"
                loadingFacture={loadingFacture}
                dataTable={venteTableFormat}
                columns={columns}
                // factureProgressBar={FactureProgressBar}
                transactionStatus={currentVente.status}
                totalTransaction={total}
                // logo={currentCompany.logo}
                fullName={currentVente.client?.firstName ? currentVente.client?.firstName + ' ' + currentVente?.client?.lastName : "......................................."}
                phone={currentVente.client?.telephone ?? '.............................'}
                // messageOnEmptyFullName="Pas de client"
                factureDate={factureDate ?? '.....................'}
                numbreJoursRestants={0}
                navigateToEdit={UPDATE_VENTE_PATH}
                currentTransactionId={currentVente.id}
                transactionDate={currentVente.date}
                openPaymentModal={openPaymentModal}
                onEdit={onEdit}
            />
        </div>
    )
}

export default VenteDetailsPage